//#region Libraries
import {
    useState, 
    useEffect } from "react";
//#endregion
//#region Services
import { 
    requestGetAllCampus,
    requestGetAllCampusDetail,
    requestGetAllDays, 
    requestGetLocations, 
    requestGetModalities } from "services/general";

import { requestGetAdvisers as requestGetPsychologyAdvisers } from "services/appointment/relatedToAppointment";
//#endregion

const useDataRelatedToForm = ({
    requestGetAdvisers = requestGetPsychologyAdvisers
} = {}) => {
    //#region States
    const [allDays, setAllDays] = useState([]);
    const [locations, setLocations] = useState([]);
    const [allCampusDetail, setAllCampusDetail] = useState([]);
    const [allCampus, setAllCampus] = useState([]);
    const [modalities, setModalities] = useState([]);
    const [allAdvisers, setAllAdvisers] = useState([]);
    const [loadedDataRelatedToForm, setLoadedDataRelatedToForm] = useState(false);
    //#endregion
    //#region Effects
    useEffect(() => {
        fetchData();
    }, []);
    //#endregion
    //#region Functions
    async function fetchData() {
        await Promise.all([
            fillAllDays(),
            fillLocations(),
            fillAllCampusDetail(),
            fillAllCampus(),
            fillModalities(),
            fillAllAdvisers()
        ]);
        setLoadedDataRelatedToForm(true);
    }
    const fillAllDays = async () => {
        const fetchAllDays = await requestGetAllDays();
        setAllDays(fetchAllDays);
    }
    const fillLocations = async () => {
        const fetchLocations = await requestGetLocations();
        setLocations(fetchLocations);
    }
    const fillAllCampusDetail = async () => {
        const fetchAllCampusDetail = await requestGetAllCampusDetail();
        setAllCampusDetail(fetchAllCampusDetail);
    }
    const fillAllCampus = async () => {
        const fetchAllCampus = await requestGetAllCampus();
        setAllCampus(fetchAllCampus);
    }
    const fillModalities = async () => {
        const fetchModalities = await requestGetModalities();
        setModalities(fetchModalities);
    }
    const fillAllAdvisers = async () => {
        const fetchAllAdvisers = await requestGetAdvisers();
        setAllAdvisers(fetchAllAdvisers || []);
    }
    //#endregion
    return {
        allDays,
        locations,
        allCampusDetail,
        allCampus,
        modalities,
        allAdvisers
    };
};

export default useDataRelatedToForm;
